/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LogsSchema } from '../models/LogsSchema';
import { Provider } from '../models/Provider';

/**
* Schema information for a resource with LLG logs.
*/
export class LogsSchemaEntry {
  /**
  * The resource ID.
  */
  'resourceId'?: string;
  /**
  * The resource name.
  */
  'resourceName'?: string;
  'cloudProvider'?: Provider;
  /**
  * The schemas available for this resource.
  */
  'schemas'?: Array<LogsSchema>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "schemas",
      "baseName": "schemas",
      "type": "Array<LogsSchema>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return LogsSchemaEntry.attributeTypeMap;
  }

  public constructor() {
  }
}



